export function ensureAuthElements(): void {
  if (typeof document === "undefined") return;
  if (!document.querySelector("sugar-login-popup")) {
    document.documentElement.appendChild(
      document.createElement("sugar-login-popup"),
    );
  }
}
